export const Support = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.95841 8.12484V7.9165C3.95841 4.8099 6.66336 2.2915 10.0001 2.2915C13.3368 2.2915 16.0417 4.8099 16.0417 7.9165V8.12484M10.0001 16.3689V16.8748C10.0001 17.3351 10.3732 17.7082 10.8334 17.7082H12.5001C14.5711 17.7082 16.2501 16.0292 16.2501 13.9582M3.54175 8.12484H4.79175V13.5415H3.54175C2.85139 13.5415 2.29175 12.9819 2.29175 12.2915V9.37484C2.29175 8.68448 2.85139 8.12484 3.54175 8.12484ZM15.2084 8.12484H16.4584C17.1488 8.12484 17.7084 8.68448 17.7084 9.37484V12.2915C17.7084 12.9819 17.1488 13.5415 16.4584 13.5415H15.2084V8.12484Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Support
